import { render, staticRenderFns } from "./ThemeTagging.vue?vue&type=template&id=4aaeccd6&scoped=true"
import script from "./ThemeTagging.vue?vue&type=script&lang=js"
export * from "./ThemeTagging.vue?vue&type=script&lang=js"
import style0 from "./ThemeTagging.vue?vue&type=style&index=0&id=4aaeccd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaeccd6",
  null
  
)

export default component.exports